import Vue from 'vue';
import { EventManager } from '../vue/EventManager.js';
import AOS from 'aos';
import VueRouter from 'vue-router';
import VueLazyload from 'vue-lazyload';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import TestComponent from '../vue/TestComponent.vue';
import SiteHeader from '../vue/SiteHeader.vue';
import SiteFooter from '../vue/SiteFooter.vue';
import PrimaryButton from '../vue/PrimaryButton.vue';
import PageHeader from '../vue/PageHeader.vue';
import CtaCta from '../vue/CtaCta.vue';
import PageDivider from '../vue/PageDivider.vue';
import FeaturedText from '../vue/FeaturedText.vue';
import RichText from '../vue/RichText.vue';
import VideoImage from '../vue/VideoImage.vue';
import MediaAndText from '../vue/MediaAndText.vue';
import ImageSlider from '../vue/ImageSlider.vue';
import WarrantyTiers from '../vue/WarrantyTiers.vue';
import BookToday from '../vue/BookToday.vue';
import NotFound from '../vue/NotFound.vue';
import GlobalCta from '../vue/GlobalCta.vue';
import ProductListing from '../vue/ProductListing.vue';
import LightboxGallery from '../vue/LightboxGallery.vue';

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(VueLazyload);
const router = new VueRouter({ mode: 'history' });

export default {
  init() {
    // JavaScript to be fired on all pages
    let vueArea = document.querySelectorAll('.app');

    let matchingElements = document.getElementsByClassName('vue-disable'),
      hiddenMarkup = [];

    for (var i = 0; i < matchingElements.length; i++) {
      hiddenMarkup.push(matchingElements[i].innerHTML);
      matchingElements[i].innerHTML = '';
    }

    Vue.config.productionTip = false;

    const store = new Vuex.Store({
      state: {
        mobile_menu: false,
        alert_bar_closed: false,
        alert_bar_id: false,
      },
      getters: {},
      mutations: {
        closeAlertBar(state, payload) {
          state.alert_bar_closed = payload;
        },
        alertBarID(state, payload) {
          state.alert_bar_id = payload;
        },
        toggleMobileMenu(state, payload) {
          state.mobile_menu = payload;
        },
      },
      actions: {},
      plugins: [createPersistedState()],
    });

    if (vueArea) {
      vueArea.forEach((element) => {
        new Vue({
          store: store,
          router,
          data: {
            topScrollThreshold: 100,
            isScrolled: false,
            isPageReady: false,
          },

          components: {
            TestComponent,
            SiteHeader,
            SiteFooter,
            PageHeader,
            ImageSlider,
            WarrantyTiers,
            BookToday,
            GlobalCta,
            ProductListing,
            LightboxGallery,
            // HeroHeader,
            // QuickLinks,
            // SlimHeaderImage,
            // SlimHeader,
            // BreadCrumbs,
            PageDivider,
            RichText,
            VideoImage,
            // IconListing,
            // AlertBanner,
            CtaCta,
            // CourseListing,
            // ProviderListing,
            // CourseCard,
            // EligibilityForm,
            // LevyCalculator,
            MediaAndText,
            FeaturedText,
            // FeaturedAppCta,
            // FeaturedPeople,
            // FundingProgramTile,
            // DeviceImage,
            // HeroImage,
            // TestimonialSlider,
            // FeaturedLogos,
            // AccordionItem,
            // AccordionWrapper,
            // DownloadsLinks,
            // FeaturedPostListing,
            // PeopleListing,
            // PostListing,
            // SimpleHeader,
            NotFound,
            // SearchListing,
            // SubmitButton,
            PrimaryButton,
            // SecondaryButton,
            // TertiaryButton,
            // FindMyNumber,
            // GetMyBalance,
            // AcknowledgementOfCountry,
            // MobilePageSelect,
          },

          methods: {
            onRefreshAos: function () {
              AOS.refresh();
            },
            didScroll() {
              this.isScrolled = window.scrollY > this.topScrollThreshold;
              this.updateTrigger();
            },

            updateTrigger() {
              var sideNav = document.querySelector(
                '.page-template-template-side_nav',
              );
              var hash = window.location.hash;
              let navAccordion = document.querySelectorAll(
                '.anchored_nav__inner',
              );

              if (hash && sideNav && navAccordion) {
                navAccordion.forEach((element) => {
                  var accordion_content = element.querySelectorAll('ul li');

                  if (accordion_content) {
                    accordion_content.forEach((element) => {
                      let theLink = element.querySelector('a');

                      if (theLink != null) {
                        if (
                          theLink.href.split('#')[1] === hash.replace('#', '')
                        ) {
                          element.classList.add('current');
                        } else {
                          element.classList.remove('current');
                        }
                      }
                    });
                  }
                });
              }
            },
          },

          created() {
            window.addEventListener('scroll', this.didScroll);
            this.updateTrigger();
          },

          destroyed() {
            window.removeEventListener('scroll', this.didScroll);
          },

          mounted() {
            var self = this;
            setTimeout(function () {
              self.isPageReady = true;
              AOS.init();
            }, 500);

            // eslint-disable-next-line no-unused-vars
            self.$Lazyload.$on(
              'loaded',
              function (
                {
                  bindType,
                  el,
                  naturalHeight,
                  naturalWidth,
                  $parent,
                  src,
                  loading,
                  error,
                },
                formCache,
              ) {
                // Lazy loading images can cause AOS to get out of sync because the loaded image changes the height of the content
                // so refreshing it in order to re-calculate trigger points
                EventManager.$emit('should-refresh-aos');
              },
            );

            const table = document.getElementById('data-table');

            if (table) {
              const rows = table.querySelectorAll('tbody tr');

              if (rows) {
                rows.forEach((row) => {
                  const inputFields = row.querySelectorAll(
                    "input[type='number']",
                  );
                  inputFields.forEach((input) => {
                    input.addEventListener('change', updateRowTotal);
                  });
                });
              }
            }

            function updateRowTotal(event) {
              const row = event.target.closest('tr');
              const inputFields = row.querySelectorAll(
                "input[type='number']:not(.total)",
              );
              let rowTotal = 0;

              inputFields.forEach((input) => {
                const value = parseFloat(input.value) || 0;
                rowTotal += value;
              });

              const totalInput = row.querySelector('.total');
              totalInput.value = rowTotal.toFixed(2);

              calculateGrandTotal(); // Recalculate grand total after updating row total
            }

            function calculateGrandTotal() {
              const totalInputs = document.querySelectorAll('.total');
              let grandTotal = 0;
              totalInputs.forEach((input) => {
                const value = parseFloat(input.value) || 0;
                grandTotal += value;
              });

              const grandTotalInput = document.getElementById('grand-total');
              grandTotalInput.value = grandTotal.toFixed(2);

              if (grandTotal > 100) {
                alert('Total must equal 100%');

                grandTotalInput.classList.add('invalid');
                grandTotalInput.required = true;
                grandTotalInput.setCustomValidity('Total must equal 100%');
              } else {
                grandTotalInput.classList.remove('invalid');
                grandTotalInput.required = false;
                grandTotalInput.setCustomValidity('');
              }
            }
          },
        }).$mount(element);

        /* Re-Attach exclusions
    ---------------------------------------------------------------------------------------------------- */

        for (var ii = 0; ii < matchingElements.length; ii++) {
          matchingElements[ii].innerHTML = hiddenMarkup[ii];
        }
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js